export default "__VITE_ASSET__DRqiPple__"